<template>
  <main>
    <div class="tomm-logo-container">
      <img
          src="@/assets/images/login-logo.svg"
          alt="TOMM Logo"
          class="tomm-logo"
      />
    </div>

    <filter-panel @generate="onGenerateReport" />

    <article v-if="report.preset">
      <!-- Report Information -->
      <p class="report-information">
        <span>Report type:</span>
        {{ report.preset.name }}
      </p>

      <p class="report-information">
        <span>Date range:</span>
        {{ report.preset.start_at }} - {{ report.preset.end_at }}
      </p>

      <!-- Search Panel & Container -->
      <section class="questionnaire-container">
        <div class="title-container">
          <div class="title-icon">
            <img src="@/assets/images/filter.svg" alt="Icon" />
          </div>

          <p class="title-text">
            <span>Filter by:</span> Questions and/or answers
          </p>

          <div class="title-information">
            <p>
              To filter by Questions: Select Questions from the dropdown on the title panel below.
            </p>

<!--            <p>-->
<!--              To filter by Questions: Select theme from menu on the left. Then-->
<!--              select Questions from the dropdown on the title panel below.-->
<!--            </p>-->

<!--            <p>-->
<!--              To filter by Answers: Click on any answer displayed. Only results-->
<!--              from participants who selected that particular answer will be-->
<!--              included in results displayed.-->
<!--            </p>-->
          </div>
        </div>

        <div class="content-container">
          <div class="search-container">
            <h1>{{ report.preset.name }}</h1>
            <search-dropdown
              :options="questionOptions"
              v-model="selectedQuestions"
            />
          </div>

          <!-- Questions -->
          <section v-for="question in report.questions" :key="question.id">
            <transition>
              <question-panel
                :title="question.title"
                v-if="selectedQuestions.includes(question.id)"
                @remove="removeQuestion(question.id)"
              >
                <component
                  v-if="question"
                  :is="tag(question)"
                  :question="question"
                />
              </question-panel>
            </transition>
          </section>
        </div>
      </section>
    </article>
  </main>
</template>

<script>
import { ReportingQuestionFactory } from '@/app/factories/ReportingQuestionFactory';
import SearchDropdown from '@/components/SearchDropdown';
import QuestionPanel from '@/components/reporting/QuestionPanel';
import FilterPanel from '@/components/reporting/FilterPanel';

export default {
  name: 'reporting',
  components: { FilterPanel, QuestionPanel, SearchDropdown },
  data() {
    return {
      selected: '',
      report: {
        preset: null,
        questions: [],
      },
      selectedQuestions: [],
    };
  },

  computed: {
    questionOptions() {
      return this.report.questions.map(({ id, title, subtitle }) => {
        let label = title;

        if (subtitle) {
          label += ` - ${subtitle}`;
        }

        return { key: id, label };
      });
    },
  },

  methods: {
    tag(question) {
      return ReportingQuestionFactory.make(question.type);
    },

    onGenerateReport(filters) {
      this.selected = filters.report;
    },

    removeQuestion(id) {
      const index = this.selectedQuestions.findIndex(q => q.id === id);
      this.selectedQuestions.splice(index, 1);
    },
  },

  watch: {
    async selected(id) {
      // Load the report.
      if (id) {
        const { data } = await this.$http.get(
          `/reporting/survey/${id}/question`,
        );

        this.report.preset = data.preset;
        this.report.questions = data.questions;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$txt_main: #3f4041;
$txt_light: #80817e;

main {
  width: 1300px;
  margin: 0 auto;

  > article {
    margin-top: calc(10vh + 20px);
  }
}

p {
  color: $txt_main;
}

.tomm-logo-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(10vh);
  z-index: 99999999;
  background: linear-gradient(180deg, white 80%, transparent);
}

.tomm-logo {
  position: fixed;
  top: 20px;
  left: 25px;
  height: calc(10vh - 40px);
  z-index: 9999999999;
}

.report-information {
  span {
    font-weight: bold;
    color: $txt_light;
  }
}

.questionnaire-container {
  margin-bottom: 25px;

  .title-container {
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 1000px 1000px 0 1000px;
    padding: 5px 12px;

    .title-icon {
      position: relative;
      width: 65px;
      height: 65px;
      background: transparent linear-gradient(92deg, #d6d6d6 0%, #868686 100%);
      margin-right: 25px;
      border-radius: 100%;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
      }
    }

    .title-text {
      font-size: 22px;
      white-space: nowrap;
      margin-right: 25px;

      span {
        color: $txt_light;
      }
    }

    .title-information {
      font-size: 13px;

      p {
        margin: 0;
      }
    }
  }

  .content-container {
    margin-left: 75px;
    padding: 25px;
    background-color: white;
    box-shadow: 0px 5px 6px #00000029;
    border-radius: 0 0 18px 18px;

    .search-container {
      background: transparent linear-gradient(90deg, #ed1979 0%, #cb03a4 100%)
        0% 0% no-repeat padding-box;
      border-radius: 18px;
      padding: 50px 25px;
      margin-bottom: 25px;

      h1 {
        color: white;
        font-size: 60px;
        font-weight: lighter;
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
